// third-party
import { createSlice } from "@reduxjs/toolkit";

// types
import { dispatch } from "../index";
import { RenewLicenseStateProps } from "types/licence-renew";

// ----------------------------------------------------------------------

const initialState: RenewLicenseStateProps = {
  step: 0,
};

// ==============================|| SLICE - CART ||============================== //

const slice = createSlice({
  name: "licence_renew",
  initialState,
  reducers: {
    // SET STEP
    setRenewLicenseStepSuccess(state, action) {
      state.step = action.payload;
    },

    // SET NEXT STEP
    setRenewLicenseNextStepSuccess(state, action) {
      state.step += 1;
    },

    // SET BACK STEP
    setRenewLicenseBackStepSuccess(state, action) {
      state.step -= 1;
    },
  },
});

// Reducer
export default slice.reducer;

export function setRenewLicenseStep(step: number) {
  return () => {
    dispatch(slice.actions.setRenewLicenseStepSuccess(step));
  };
}

export function setRenewLicenseNextStep() {
  return () => {
    dispatch(slice.actions.setRenewLicenseNextStepSuccess({}));
  };
}

export function setRenewLicenseBackStep() {
  return () => {
    dispatch(slice.actions.setRenewLicenseBackStepSuccess({}));
  };
}
